import axios from 'axios'
import { randomString } from '@/libs/util'
import OSS from 'ali-oss'

export default {
  methods: {
    async uploadHttp ({ file }) {
      const random_name = randomString(32) + '.' + file.name.split('.').pop()
      const { data } = await axios.get('/sts')

      const conf = {
        region: 'oss-cn-hangzhou',
        accessKeyId: data.access_key_id,
        accessKeySecret: data.access_key_secret,
        stsToken: data.security_token,
        bucket: 'fresh-picture'
      }
      const ossClient = new OSS(conf)

      ossClient.put(random_name, file, {
        ContentType: 'image/*'
      }).then(({ res, url, name }) => {
        if (res && res.status === 200) {
          this.url = url
          this.$emit('uploadedUrl', url)
        }
      }).catch((err) => {
        console.log('阿里云OSS上传图片失败回调', err)
      })
    },
    beforeUpload (file) {
      const isJPG = file.type === 'image/jpeg' || 'image/jpg' || 'image/png' || 'image/gif'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传商品图片的格式不正确!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    }
  }
}
